import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";

export class KommentarerTjeneste {
    static regNavn = "KommentarerTjeneste";

    static forInjisering() {
        return [
            KommentarerTjeneste
        ]
    }

    constructor() {
    }

    //statiske hjelpemetoder

    static varsledeEksTrådForfatter(kommentar: l.KommentarModell): l.GruppeMedlemListeModell[] {
        return _(kommentar.varslede)
            .filter(medlem => medlem.id !== kommentar.publisertAv.id)
            .value();
    }

    static antallKommentarerOgSvar(kommentarer: l.KommentarModell[]): number {
        return _(kommentarer)
            .map(kommentar => kommentar.svar.length + 1)
            .sum();
    }
}

